import { dataUpload } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUpload = /*#__PURE__*/createIcon(dataUpload)
export default IconUpload
